<template>
  <div class="success">
    <div class="headImgs">
      <img src="../../assets/imgs/apply/market.png" />
    </div>
    <div class="rightPart">
      <el-container class="layout-container">
        <el-aside>
          <el-menu
            background-color="#fff"
            text-color="#000"
            active-text-color="#fff"
            :active-background-color="'#005392'"
            :hover-background-color="'#005392'"
            @select="handleMenuSelect"
            :default-active="currentTabType"
            class="el-menu-demo"
          >
            <template slot="title">全国信用网站一体化公示栏目</template>
            <el-menu-item index="1">行政许可</el-menu-item>
            <el-menu-item index="2">行政处罚</el-menu-item>
            <el-menu-item index="3">诚实守信</el-menu-item>
            <el-menu-item index="5">严重失信主体名单</el-menu-item>
            <el-menu-item
              :style="{backgroundColor: 'transparent !important', color: 'inherit !important'}"
              class="no-effect-menu-item"
              index="5-1"
              @click="openExternalLink"
            >失信被执行人</el-menu-item>
            <el-menu-item index="4">重大税收违法案件当事人</el-menu-item>
            <el-menu-item
              :style="{backgroundColor: 'transparent !important', color: 'inherit !important'}"
              class="no-effect-menu-item"
              index="7-1"
              @click="goopenExternalLink"
            >苏州市级"双公示"目录汇总表</el-menu-item>
          </el-menu>
        </el-aside>
        <el-main>
          <showList :type="currentTabType"></showList>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
import showList from "./compinents/showList.vue";
export default {
  components: { showList },
  // computed: {
  //   index() {
  //     return this.$route.query.index;
  //   }
  // },
  mounted() {
    // console.log("路由参数:", this.$route.query.index);
    // console.log("本地存储:", localStorage.getItem("currentTabType"));
    // console.log("页面来源:", document.referrer);
    // console.log(
    //   "导航类型:",
    //   performance.getEntriesByType("navigation")[0].type
    // );
    if (document.referrer) {
      this.currentTabType = this.$route.query.index;
    } else {
      this.currentTabType = localStorage.getItem("currentTabType");
    }
  },
  data() {
    return {
      currentTabType:
        this.$route.query.index || localStorage.setItem("currentTabType")
    };
  },
  watch: {
    currentTabType(index) {
      localStorage.setItem("currentTabType", index);
      this.currentTabType = index;
    }
  },
  methods: {
    handleMenuSelect(index) {
      if (index === "5-1" || index === "7-1") {
        return;
      }
      this.currentTabType = index;
      // 更新URL但不刷新页面
      this.$router.replace({
        query: { index: index }
      });
    },
    openExternalLink() {
      window.open("http://zxgk.court.gov.cn/shixin/", "_blank");
      // this.currentTabType = "1";
    },
    goopenExternalLink(index) {
      const path = this.$router.resolve({
        path: "/xyd/summList",
        query: { index }
      }).href;
      window.open(path, "_blank");
      // this.currentTabType = "1";
    }
  }
};
</script>

<style lang="less" scoped>
.success {
  background-color: #fff;
  .headImgs {
    img {
      width: 100%;
      height: 200px;
    }
  }
  .rightPart {
    /* 深度覆盖确保样式优先级 */
    ::v-deep .el-menu-item:hover {
      background-color: inherit !important; /* 继承父级颜色 */
      color: inherit !important; /* 继承父级文字颜色 */
      cursor: default !important; /* 移除手型光标 */
    }

    /* 保留选中状态样式 */
    ::v-deep .el-menu-item.is-active {
      background-color: #005392 !important;
      color: #fff !important;
    }
    //
    .no-effect-menu-item {
      background-color: transparent !important;
    }
    .no-effect-menu-item:hover {
      background-color: transparent !important;
      color: inherit !important;
    }
    .no-effect-menu-item.is-active {
      background-color: transparent !important;
      color: inherit !important;
    }
  }
}
</style>